import React, { useState, useEffect, useRef } from 'react';
import { X, Code, ChevronUp, Layers, Database, Layout } from 'lucide-react';

const SlashEasyWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const widgetRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (widgetRef.current && !widgetRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const toggleWidget = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div 
      ref={widgetRef}
      className="fixed bottom-4 right-4 z-[9999] font-sans flex flex-col items-end pointer-events-none"
    >
      {/* Tech Stack Card */ }
      <div 
        className={`
          mb-4 w-72 bg-[#0F172A] border border-[#D4AF37]/30 rounded-xl shadow-[0_0_30px_rgba(0,0,0,0.5)] 
          overflow-hidden transition-all duration-300 ease-out origin-bottom-right
          ${isOpen ? 'opacity-100 scale-100 translate-y-0 pointer-events-auto' : 'opacity-0 scale-95 translate-y-4 pointer-events-none'}
        `}
      >
        {/* Header */ }
        <div className="bg-gradient-to-r from-[#D4AF37] to-[#B8860B] p-4 flex justify-between items-center text-[#0A1128]">
          <div className="flex items-center gap-2 font-bold">
            <Code size={18} strokeWidth={3} />
            <span>Tech Stack</span>
          </div>
          <button 
            onClick={() => setIsOpen(false)}
            className="hover:bg-black/10 p-1 rounded-full transition-colors"
          >
            <X size={18} />
          </button>
        </div>

        {/* Content */ }
        <div className="p-4 space-y-4 text-white">
          <div className="flex items-start gap-3">
            <div className="p-2 bg-blue-500/10 rounded-lg text-blue-400 mt-1">
              <Layout size={18} />
            </div>
            <div>
              <p className="text-[#94A3B8] text-xs uppercase tracking-wider font-semibold">Frontend</p>
              <p className="font-medium text-sm">React.js</p>
              <p className="text-xs text-[#64748B]">(with React Query)</p>
            </div>
          </div>

          <div className="h-px bg-white/10" />

          <div className="flex items-start gap-3">
            <div className="p-2 bg-emerald-500/10 rounded-lg text-emerald-400 mt-1">
              <Database size={18} />
            </div>
            <div>
              <p className="text-[#94A3B8] text-xs uppercase tracking-wider font-semibold">Backend & Database</p>
              <p className="font-medium text-sm">FastAPI & MongoDB</p>
            </div>
          </div>
          
           <div className="h-px bg-white/10" />
           
           <div className="pt-2 text-center">
             <p className="text-[10px] text-[#64748B]">Built with ❤️ by SlashEasy</p>
           </div>
        </div>
      </div>

      {/* Trigger Button */ }
      <button
        onClick={toggleWidget}
        className={`
          group relative flex items-center gap-2 px-5 py-3 
          bg-[#0F172A] hover:bg-[#1E293B] text-white 
          border border-[#D4AF37]/50 rounded-full 
          shadow-[0_0_20px_rgba(212,175,55,0.2)] hover:shadow-[0_0_25px_rgba(212,175,55,0.4)]
          transition-all duration-300 pointer-events-auto
        `}
      >
        <div className="w-2 h-2 rounded-full bg-[#D4AF37] animate-pulse" />
        <span className="font-medium text-sm">Built by SlashEasy</span>
        <ChevronUp 
          size={16} 
          className={`text-[#D4AF37] transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
        />
      </button>
    </div>
  );
};

export default SlashEasyWidget;
